export enum LevelIds {
  FUTURES = '6630e7a56dc89f8784fe3298',
  UPPERS = '6630e79e6dc89f8784fe3295',
  ADULTS = '6638fe6b59686eb9c0353706',
}
